import { handleActions } from 'redux-actions';

import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from '../../utils/redux/getCRUDSagas';

import * as commonActionHandlers from '../../utils/redux/commonActionHandlers';

import Api from '../../utils/resourcesApi';

import { DEFAULT_YEAR } from './component/years';

// The list of Master Account months (FIN-1263) — the plain CRUD feature, with
// nothing extended onto it, because there is nothing to create, edit or delete
// here. The MONTH itself is a page of its own (./Month), which reads its data
// straight from the resource: one fetch, no store, nothing to keep in sync.
export const constants = getConstantsByFeatureName('MASTER_ACCOUNTS');

export const actions = getActionCreators(constants);

// The list opens on the current year, like the Requisition Lists one. Set here
// rather than applied from the toolbar on mount: a default that arrives after
// the first request costs a second round trip and a flash of the wrong rows.
const initialState = {
  ...commonActionHandlers.initialState,
  filter: { ...commonActionHandlers.initialState.filter, year: DEFAULT_YEAR },
};

export const reducer = handleActions(getActionHandlers(constants), initialState);

export const selector = getSelectorByFeatureName('masterAccounts');

export const sagas = getCRUDSagas(
  '/dax_info',
  Api.daxMasterAccountMonths,
  actions,
  constants,
  'masterAccounts',
  'masterAccounts',
);
